import * as React from 'react';
import { NavContext } from './NavContext'; // This is a PureComponent so that setting state to loading
// when it is already loading won't cause a re-render

export function NavLoading(props) {
  return React.createElement(NavContext.Consumer, null, function (context) {
    return props.children(context.busyRoute);
  });
}